import React from "react";
import styled, { keyframes } from "styled-components";
import { Icon } from "semantic-ui-react";
import SelectCard from "new_components/organisms/SelectCard";
import { ICON_SET } from "new_components/atoms/Icon/IconSet";
import colors from "styles/colors";

const SelectReportTemplateStep = ({ onSelect, backAction }) => {
  return (
    <Container>
      <BackButton onClick={backAction}>
        <Icon name="chevron left" style={{ marginTop: -7 }} /> Back
      </BackButton>
      <T1>Report Creation</T1>
      <Description>Please select a report template option</Description>
      <Options>
        <SelectCard
          iconName={ICON_SET.userIcon}
          onClick={() =>
            onSelect({ reportType: 1, config: { key: "culture" } })
          }
          iconBgColor={colors.primary[50]}
          title="Culture Summary"
          description="This report summarizes the information for each culture factor. The data for each culture factor is analyzed and summarized."
          reportLength={1}
          extraWide
        />
        <SelectCard
          iconName={ICON_SET.dashboard}
          onClick={() => onSelect({ reportType: 4, config: { key: "org" } })}
          extraWide
          iconBgColor={colors.primary[50]}
          title="Organization Culture Summary"
          description="This report summarizes the information for each culture factor for the entire organization. The data for each culture factor is analyzed and summarized."
          reportLength={1}
        />
        <SelectCard
          iconName={ICON_SET.dashboard}
          onClick={() =>
            onSelect({ reportType: 12, config: { key: "descriptive" } })
          }
          extraWide
          iconBgColor={colors.primary[50]}
          title="Descriptive Analytics Report"
          description="This report summarizes the information for each culture factor for the entire organization. The data for each culture factor is analyzed and summarized."
          reportLength={30}
        />
      </Options>
    </Container>
  );
};

export default SelectReportTemplateStep;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  width: 100%;
  font-family: "Raleway";
  display: flex;
  flex-direction: column;
`;

const BackButton = styled.div`
  font-size: 14px;
  color: #b3b3b3;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 12px;
  margin-bottom: 20px;
`;

const T1 = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  font-family: "Raleway";
  color: #2a3039;
  line-height: 1.5;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  letter-spacing: -0.35px;
`;

const Description = styled.div`
  font-size: 16px;
  color: #2a3039;
  margin-bottom: 20px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 0.5s;
`;

const Options = styled.div`
  display: flex;
  flex-direction: row;
  opacity: 0;
  animation: ${fadeIn} 1s ease-out forwards;
  animation-delay: 1s;
`;
